import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="py-10 px-4 bg-blue-900 text-white" data-id="element-100">
      <div className="max-w-6xl mx-auto text-center" data-id="element-101">
        <p data-id="element-102">© {currentYear} Adeyeye Afeez. All rights reserved.</p>
      </div>
    </footer>;
}